type UpdateExamMetadataInput = {
	examDate: string;
	id: string;
};

const updateExamMeta = async (
	_input: UpdateExamMetadataInput,
): Promise<boolean> => {
	return true;
};

export default updateExamMeta;
